<div class="flex py-3">
  <div class="flex-1">
    <h1 class="text-3xl font-semibold">{{ getTabName() | removeS }} Details</h1>
    <p class="text-lg text-gray-600">
      Comprehensive information about this {{ getTabName() | lowercase }}
    </p>
  </div>
  <div class="flex">
    <button
      pButton
      icon="pi pi-times"
      class="p-button-rounded p-button-danger mt-2 p-button-text"
      (click)="closeDialog()"
    ></button>
  </div>
</div>

<share-section-card title="Information Overview" icon="pi pi-list" shadow="shadow-1">
  <ul class="list-none p-0 m-0 border-top-1 surface-border" *ngIf="deviceFieldsToDisplay.length">
    <li
      *ngFor="let dataField of deviceFieldsToDisplay; let i = index"
      class="flex align-items-center py-3 px-3 flex-wrap"
      [ngClass]="{ 'surface-ground': i % 2 !== 0 }"
    >
      <div class="text-500 font-medium w-full md:w-4">{{ formatFieldLabel(dataField.key) }}</div>
      <div class="text-900 w-full md:w-8">
        <ng-container [ngSwitch]="getFieldType(dataField.key, dataField.value)">
          <!-- Text/String Values -->
          <span *ngSwitchCase="'text'">{{ dataField.value || 'N/A' }}</span>

          <!-- Date Values -->
          <span *ngSwitchCase="'date'">
            {{ isDateValue(dataField.value) ? (dataField.value | date: 'mediumDate') : 'N/A' }}
          </span>

          <!-- Number Values -->
          <span *ngSwitchCase="'number'">
            {{ isNumberValue(dataField.value) ? (dataField.value | number: '1.0-2') : '0' }}
          </span>

          <!-- Currency Values -->
          <span *ngSwitchCase="'currency'">
            {{
              isNumberValue(dataField.value)
                ? (dataField.value | currency: 'ZAR' : 'symbol-narrow' : '1.2-2')
                : 'R0.00'
            }}
          </span>

          <!-- Boolean Values -->
          <p-tag
            *ngSwitchCase="'boolean'"
            [value]="isBooleanValue(dataField.value) ? 'Yes' : 'No'"
            [severity]="isBooleanValue(dataField.value) ? 'success' : 'danger'"
          ></p-tag>

          <!-- Status Values -->
          <p-tag
            *ngSwitchCase="'status'"
            [value]="isStringValue(dataField.value) ? (dataField.value | uppercase) : 'N/A'"
            [severity]="getStatusSeverity(dataField.value)"
          ></p-tag>

          <!-- URL Values -->
          <a
            *ngSwitchCase="'url'"
            [href]="isStringValue(dataField.value) ? dataField.value : '#'"
            target="_blank"
          >
            {{ isStringValue(dataField.value) ? dataField.value : 'N/A' }}
          </a>

          <!-- Email Values -->
          <a
            *ngSwitchCase="'email'"
            [href]="isStringValue(dataField.value) ? 'mailto:' + dataField.value : '#'"
          >
            {{ isStringValue(dataField.value) ? dataField.value : 'N/A' }}
          </a>

          <!-- Default/Unknown Type -->
          <span *ngSwitchDefault>{{ isStringValue(dataField.value) ? dataField.value : 'N/A' }}</span>
        </ng-container>
      </div>
    </li>
  </ul>

  <!-- Empty State -->
  <div *ngIf="deviceFieldsToDisplay.length === 0" class="text-center p-4">
    <i class="pi pi-inbox text-400 mb-2 block" style="font-size: 2rem"></i>
    <p class="text-500">No details available for this {{ getTabName() | lowercase }}</p>
  </div>
</share-section-card>
